var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    transform: "translate(0 33) rotate(-90)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9687 16.5C31.9687 7.95684 25.0432 1.03125 16.5 1.03125C7.95684 1.03125 1.03125 7.95684 1.03125 16.5C1.03125 25.0432 7.95685 31.9687 16.5 31.9687C25.0432 31.9687 31.9687 25.0432 31.9687 16.5ZM3.09375 16.5C3.09375 9.09593 9.09593 3.09375 16.5 3.09375C23.9041 3.09375 29.9062 9.09593 29.9062 16.5C29.9062 23.9041 23.9041 29.9062 16.5 29.9062C9.09593 29.9062 3.09375 23.9041 3.09375 16.5ZM23.4197 14.7366L16.5 21.6562L9.58031 14.7469L11.0447 13.2825L16.5 18.7378L21.9553 13.2722L23.4197 14.7366Z",
    fill: "#009FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownCircle);
export default __webpack_public_path__ + "static/media/chevron-down-circle.9d92645fe86aedcadd9a5137968238b1.svg";
export { ForwardRef as ReactComponent };